import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { fetchContainerDetails } from 'src/store/common-slices/getContainerSlice';
import JackpotScanTote from './JackpotScanTote';
import { GetContainerDetailsInput } from 'src/models/GetContainerDetails';

const mapStateToProps = (state: RootState) => ({
    containerDetails: state.GetContainer.containerDetailsOutput?.container,
    childContainers: state.GetContainer.containerDetailsOutput?.childContainers,
    uiAlertState: state.UI.alertState,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    fetchContainerDetails: (getContainerDetailsInput: GetContainerDetailsInput) => dispatch(fetchContainerDetails(getContainerDetailsInput)),
});

export default connect(mapStateToProps, mapDispatchToProps)(JackpotScanTote);
